export const isProd = () => process.env.NEXT_PUBLIC_ENV === 'production';

/**
 * ビルド環境では、next build により、NODE_ENV が production になる。
 */
export const isBuildEnv = () => process.env.NODE_ENV === 'production';

export const isLocal = () => !isBuildEnv();
